import React from 'react'
import { useTranslation } from 'react-i18next'

export const EXTERNAL_MENU_ROUND_OPTIONS = [
	{ id: 10, name: '10' },
	{ id: 50, name: '50' },
	{ id: 100, name: '100' },
	{ id: 500, name: '500' },
	{ id: 1000, name: '1000' },
	{ id: 10000, name: '10000' },
]

function ExternalMenuSyncForm({ syncOptions, setSyncOptions, idPrefix = 'sync' }) {
	const { t } = useTranslation()

	return (
		<div>
			<div className="form-check">
				<input
					id={`${idPrefix}-name`}
					className="form-check-input"
					type="checkbox"
					checked={syncOptions?.name}
					onChange={(e) => setSyncOptions({ ...syncOptions, name: e.target.checked })}
				/>
				<label className="form-check-label" htmlFor={`${idPrefix}-name`}>
					{t('name2')} & {t('description')}
				</label>
			</div>
			<div className="form-check">
				<input
					id={`${idPrefix}-weight`}
					className="form-check-input"
					type="checkbox"
					checked={syncOptions?.weight}
					onChange={(e) => setSyncOptions({ ...syncOptions, weight: e.target.checked })}
				/>
				<label className="form-check-label" htmlFor={`${idPrefix}-weight`}>
					{t('weight')}
				</label>
			</div>
			<div className="form-check">
				<input
					id={`${idPrefix}-image`}
					className="form-check-input"
					type="checkbox"
					checked={syncOptions?.image}
					onChange={(e) => setSyncOptions({ ...syncOptions, image: e.target.checked })}
				/>
				<label className="form-check-label" htmlFor={`${idPrefix}-image`}>
					{t('image')}
				</label>
			</div>
			<div className="form-check">
				<input
					id={`${idPrefix}-price`}
					className="form-check-input"
					type="checkbox"
					checked={syncOptions?.price}
					onChange={(e) => setSyncOptions({ ...syncOptions, price: e.target.checked, clear_price: false })}
				/>
				<label className="form-check-label" htmlFor={`${idPrefix}-price`}>
					{t('sale_price')}
				</label>
			</div>
			<div className="form-check">
				<input
					id={`${idPrefix}-clear-price`}
					className="form-check-input"
					type="checkbox"
					checked={syncOptions?.clear_price}
					onChange={(e) => setSyncOptions({ ...syncOptions, clear_price: e.target.checked, price: false })}
				/>
				<label className="form-check-label" htmlFor={`${idPrefix}-clear-price`}>
					{t('clear_menu_prices')}
				</label>
			</div>
			{!!syncOptions?.clear_price &&
				<div className="text-muted">{t('menu_price_from_pos_hint')}</div>
			}

			{!!syncOptions.price && !syncOptions.clear_price &&
				<>
					<br />
					<div className="d-flex flex-wrap w-100">
						<b>{t('round')}:</b>
						{EXTERNAL_MENU_ROUND_OPTIONS.map((item) => (
							<div
								className="form-check delivery"
								key={item.id}
								onClick={() =>
									setSyncOptions(prev => ({
										...prev,
										round: prev.round === item.id ? null : item.id,
									}))
								}>
								<div
									className="radio-round"
									style={{ backgroundColor: syncOptions.round === item.id ? 'black' : '' }}>
								</div>
								<span>{item.name}</span>
							</div>
						))}
					</div>
					<div className="d-flex justify-content-between">
						<b className="align-content-center">{t('markup')}%:</b>
						<div style={{ width: '100px' }}>
							<input
								type="number"
								className="form-control"
								value={syncOptions.markup ?? ''}
								onChange={(e) => setSyncOptions({ ...syncOptions, markup: e.target.value })}
							/>
						</div>
					</div>
				</>
			}
		</div>
	)
}

export default ExternalMenuSyncForm
